<span mat-button mat-dialog-close class="right pointer"><i id="closeOverlay" class="far fa-times-circle"></i></span>
<h1 mat-dialog-title>Note</h1>
<div mat-dialog-content>
  <div class="has-cols">

    <div class="grid-element-full">
      <label>Note</label>
      <textarea #notes rows="5"></textarea>
    </div>
  
    <div class="col-48 grid-element">
      <label>Product Management</label>
      <select id="selezionePartner" type="text" #productManagement>
        <option selected disabled></option>
        <option value="deluxywarehouse">Magazzino Deluxy</option>
        <option value="returntobouquet">Ritorno in Boutique</option>
        <option value="keptincar">Tenuto in Macchina</option>
      </select>
    </div> 
  </div>
</div>
<div mat-dialog-actions>
  <div>
    <button mat-button class="btn" (click)=onSubmit()>Salva</button>
  </div>
</div>
